import { Box, Grid, Skeleton, Typography } from "@mui/material"
import BaseLink from "../BaseLink"
import { useParams } from "react-router-dom"
import { useSelector } from "react-redux"
import { useMemo } from "react"
import { findMemberByUserId } from "../../utils/member-lookup"

const StatementSection = ({ dataUpdatedAt }) => {
  const { id: patient_id, report_name } = useParams()
  const members = useSelector(state => state.members)
  const loadingAuth = useSelector(state => state.loadingAuth)
  const selectedPatient = useMemo(() => findMemberByUserId(members, patient_id), [members, patient_id])
  const reports = useSelector(state => state.patientReports)
  const reportDetail = useMemo(() => report_name ? reports.find(item => item.value === report_name) : null, [reports, report_name])

  return (
    <Box
      sx={{
        mt: '16px',
        position: 'relative',
        zIndex: 1
      }}
    >
      <Box
        sx={{
          width: { md: '82%' },
          borderRadius: '8px',
          border: '1px solid',
          borderColor: 'primary.lightGray',
          padding: '16px',
          bgcolor: 'primary.white',
        }}
      >
        <Typography variant="h4">
          We analyze&nbsp;
          <BaseLink 
            to={`/how-it-works#${report_name}`} 
            sx={{
                color: 'primary.darkBlue',
                textDecoration: 'underline !important',
                fontStyle: 'italic'
            }}
          >these entire genes</BaseLink>
          &nbsp;for this report using state-of-the-art methods, and continuously update this to make sure the risk information is as current as possible.
        </Typography>
      </Box>
      <Box
        sx={{
          mt: '16px'
        }}
      >
        <Grid container spacing='16px'>
          <Grid item xs={6}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Typography
                variant="body"
                sx={{
                  color: 'primary.darkGray'
                }}
              >
                Member:
              </Typography>
              {loadingAuth ? (
                <Skeleton variant="rounded" width={80} height={24} />
              ) : (
                <Typography
                  variant="body"
                >
                  {selectedPatient?.user?.name}
                </Typography>
              )}
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Typography
                variant="body"
                sx={{
                  color: 'primary.darkGray'
                }}
              >
                Updated on:
              </Typography>
              {loadingAuth ? (
                <Skeleton variant="rounded" width={80} height={24} />
              ) : (
                <Typography
                  variant="body"
                >
                  {reportDetail?.dataUpdatedAt || dataUpdatedAt}
                </Typography>
              )}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}

export default StatementSection